import React, { Component } from "react";

import { withTranslation } from 'react-i18next';
import { TFunction, i18n } from 'i18next';
import { ITheme, IStyle } from 'office-ui-fabric-react/lib/Styling';
import { EngineeringScreen } from "../side_panel/EngineeringScreen";
import { IStyleFunctionOrObject, customizable } from '@uifabric/utilities/lib/';
import { OnSendNotification, } from '../../ts/infrastructure';
import { globalContext } from '../helpers/GlobalContexts';

interface State {

}

/**
 * This interface defines the props of the dialog component.
 */
interface Props {
    t: TFunction,
    tReady: boolean,
    i18n: i18n,
    theme?: ITheme,
    styles?: IStyleFunctionOrObject<StyleProps, Styles>;
}

interface StyleProps {
    theme?: ITheme;
}

interface Styles {
    content: IStyle;
}

/**
 * This component is the top-level component of the generic dialog popup.
 */
@customizable('EngineeringDialogComponent', ['theme', 'styles'], true)
class EngineeringDialogComponent extends Component<Props, State> {
    static contextType = globalContext;
    declare context: React.ContextType<typeof globalContext>;

    protected UUID: string;

    state: State = {

    };

    constructor(props: Props) {
        super(props);
    }

    /**
     * This callback runs when the user clicks the close dialog button and stops the email transmission
     */
    protected onClose = async () => {
        const notification = {
            message: "User closed dialog",
            success: false
        } as OnSendNotification;

        Office.context.ui.messageParent(JSON.stringify(notification));
    }

    /**
     * This function runs once during the initialisation of the component.
     */
    public async componentDidMount() {

    }

    /**
     * This function runs when the component is about to be removed
     */
    public async componentWillUnmount() {
    }

    /**
    * This function is called every time the component is rendered.
    */
    public render() {
        //const { t, theme } = this.props;


        return (
            <EngineeringScreen {...this.props}></EngineeringScreen>
        );
    }
}

export default withTranslation()(EngineeringDialogComponent);